import {
    CORE_LOAD_MASTER_DATA_COATINGS_REQUEST,
    CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS,
    CORE_LOAD_MASTER_DATA_COATINGS_FAILURE,

    CORE_LOAD_MASTER_DATA_COATING_REQUEST,
    CORE_LOAD_MASTER_DATA_COATING_SUCCESS,
    CORE_LOAD_MASTER_DATA_COATING_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterCoatings: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_COATINGS_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_COATINGS_FAILURE:
                return []
            default:
                return state
        }
    },
    masterCoating: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_COATING_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_COATING_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_COATING_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/coating.js